import { Component, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PurchaseTypeEnum } from "@enums/purchaseType.enum";
import { MaterialType } from "@enums/materialType.enum";
import { RequestForQuoteStatusEnum } from "@enums/requestForQuoteStatus.enum";
import { environment } from "@environments/environment";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { RequestForQuoteLineItem } from "@interfaces/data/requestForQuoteLineItem.interface";
import { RequestForQuoteOutsourcedLineItem } from "@interfaces/data/requestForQuoteOutsourcedLineItem.interface";
import { OutsourcedSpecification } from "@interfaces/models/outsourcedSpecification.interface";
import { RequestForQuote } from "@interfaces/models/requestForQuote.interface";
import { Supplier } from "@interfaces/models/supplier.interface";
import { PurchasableItem } from "@interfaces/purchasableItem.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { AuthService } from "@services/auth.service";
import { OutsourcedSpecificationService } from "@services/outsourcedSpecification.service";
import { PurchasableItemService } from "@services/purchasableItem.service";
import { RequestForQuoteService } from "@services/requestForQuote.service";
import { SupplierService } from "@services/supplier.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";
import { DxDataGridComponent } from "devextreme-angular";
import ArrayStore from "devextreme/data/array_store";
import DataSource from "devextreme/data/data_source";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "requestForQuotes-id",
	styleUrls: ["requestForQuotes-id.css"],
	templateUrl: "requestForQuotes-id.html"
})
export class RequestForQuotesIdAdminComponent {
	@ViewChild("gridContainer", { static: false }) dataGrid!: DxDataGridComponent;
	billetLineItems: any[] = [];
	changes: any = [];
	createEnabled = false;
	editEnabled = true;
	editRowKey: any = null;
	groupedPurchasableItems: DataSource | undefined;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	headerTertiaryButtons: AdminHeaderButton[] = [];
	item: RequestForQuote = new RequestForQuote();
	itemType = "RFQ";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	lineItemPurchasableItem: PurchasableItem = new PurchasableItem();
	lineItems: RequestForQuoteLineItem[] = [];	
	materialTypes = GetPropertiesFromEnum(MaterialType);
	outsourcedLineItems: RequestForQuoteOutsourcedLineItem[] = [];	
	outsourcedSpecifications: OutsourcedSpecification[] = [];
	people: UserProfile[] = [];
	purchasableItems: PurchasableItem[] = [];
	purchaseTypes: any;
	readOnly = true;
	readOnlyAlways = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	screenMode = "";
	showLineItemButtons = true;
	statuses: any;
	suppliers: Supplier[] = [];
	thicknesses: number[] = environment.build.thicknesses;
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private authServices: AuthService, private itemService: RequestForQuoteService, private outsourcedSpecificationService: OutsourcedSpecificationService, private purchasableItemService: PurchasableItemService, private supplierService: SupplierService, private userProfileService: UserProfileService) {
		this.getPeople();
		this.getOutsourcedSpecifications();
		this.getSuppliers();
		this.purchaseTypes = GetPropertiesFromEnum(PurchaseTypeEnum);
		this.statuses = GetPropertiesFromEnum(RequestForQuoteStatusEnum);
		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.getItem(params.id.split("_")[0], "edit");
					this.edit();
				} else {
					this.getItem(params.id, "view");
				}
			} else {
				this.create();
				this.buildButtons("create");
			}
		});
	}

	buildButtons(mode: string) {
		this.screenMode = mode;
		this.headerSecondaryButtons = [];
		this.headerTertiaryButtons = [];

		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			if (this.item.status == RequestForQuoteStatusEnum.Pending) {				
				this.headerPrimaryButtons = [
					{ method: "edit", text: "Edit" }
				];
			}
			this.headerPrimaryButtons.push({ method: "close", text: "Close" });
			if (this.item.status != RequestForQuoteStatusEnum.Lost && this.item.status != RequestForQuoteStatusEnum.Won) {
				this.headerTertiaryButtons = [
					{ icon: "fal fa-mailbox", method: "sendEmail", text: "Send" },
					{ icon: "fal fa-thumbs-up", method: "won", text: "Won" },
					{ icon: "fal fa-thumbs-down", method: "lost", text: "Lost" }
				];
			}
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.title = "Create New " + this.itemType;
	}

	createItem() {		
		this.authServices.getCurrentUserProfile()
			.subscribe(
				(res: any) => { 
					const user = res.response;
					this.item.createdById = user.id;
					this.item.lineItems = JSON.stringify(this.lineItems);
					this.item.outsourcedLineItems = JSON.stringify(this.outsourcedLineItems);
					
					this.itemService.createSingle(this.item)
						.subscribe(
							() => {
								this.toastService.success("Successfully Created " + this.itemType);
								this.close();
							},
							(err) => {
								console.log(err);
								this.toastService.error("Something Went Wrong!");
							}
						);
				},
				(err) => console.log(err)
			);
	}

	edit() {
		this.readOnly = false;
		this.title = "Edit " + this.itemType;
		this.buildButtons("edit");
		this.toastService.warn("You are now editing...");
	}

	formDataChanged(args: any) {
		switch (args.dataField) {
			case "supplierId":
				this.getPurchasableItems();
				break;
		}
	}

	getItem(lookupId: Guid, buttonMode: string) {
		this.itemService.getSingleByLookupId(lookupId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
					this.lineItems = JSON.parse(this.item.lineItems);
					this.outsourcedLineItems = JSON.parse(this.item.outsourcedLineItems);
					this.billetLineItems = this.item.billetLineItems ? JSON.parse(this.item.billetLineItems) : [];
					this.getPurchasableItems();
					this.buildButtons(buttonMode);
					this.showLineItemButtons = this.item.status === RequestForQuoteStatusEnum.Pending;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getOutsourcedSpecifications()	{
		this.outsourcedSpecificationService.getAll()
			.subscribe(
				(res: any) => {
					this.outsourcedSpecifications = res.response.items;

					this.outsourcedSpecifications.sort((a,b) => a.specification.localeCompare(b.specification));
				},
				(err) => console.log(err)
			);
	}
	
	getPeople() {
		this.userProfileService.getActiveUsers()
			.subscribe(
				(res: any) =>  {
					this.people = res.response;
					this.people.sort((a,b) => a.fullName.localeCompare(b.fullName));
				},
				(err) => console.log(err)
			);
	}
	
	getPurchasableItems() {
		this.purchasableItemService.getForSupplier(this.item.supplierId)
			.subscribe(
				(res: any) =>  {
					this.purchasableItems = res.response;
					const transformedPurchasableItems: any = [];

					this.purchasableItems.forEach(purchasableItem => {
						transformedPurchasableItems.push({ category: `${PurchaseTypeEnum[purchasableItem.purchaseType]}`, id: purchasableItem.id, name: purchasableItem.name });
					});

					this.groupedPurchasableItems = new DataSource({
						group: "category",
						store: new ArrayStore({
							data: transformedPurchasableItems,
							key: "id",
						}),
					});
				},
				(err) => console.log(err)
			);
	}
	
	getSuppliers() {
		this.supplierService.getAll()
			.subscribe(
				(res: any) =>  {
					this.suppliers = res.response.items;
					this.suppliers.sort((a,b) => a.name.localeCompare(b.name));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	lost() {
		if (confirm("Are you sure you wish to mark this RFQ as Lost? This cannot be undone.") == false) {
			return;
		}

		this.itemService.lost(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Marked as Lost");
					this.getItem(this.item.lookupId, this.screenMode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	sendEmail() {
		if (confirm("Are you sure you wish to send this RFQ? Please ensure the supplier RFQ contact and the details below are correct. You will not be able to edit this RFQ after sending it.") == false) {
			return;
		}

		this.itemService.send(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Sent");
					this.getItem(this.item.lookupId, this.screenMode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateItem() {
		this.item.lineItems = JSON.stringify(this.lineItems);
		this.item.outsourcedLineItems = JSON.stringify(this.outsourcedLineItems);
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
					// this.cancelEditing();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	won() {
		if (confirm("Are you sure you wish to mark this RFQ as Won? This cannot be undone, and may mark other related RFQs as Lost.") == false) {
			return;
		}

		this.itemService.won(this.item.id)
			.subscribe(
				() => {
					this.toastService.success("Successfully Marked as Won");
					this.getItem(this.item.lookupId, this.screenMode);
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}